import React from "react";
import PropTypes from "prop-types";
import $ from "jquery";

import { purposeShape } from "./purpose_filter";
import BasicReactTableWrapper from "../../shared_components/basic_react_table_wrapper";

const makeIcons = tags => {
  return tags.map(tag => {
    let r = tag.name;
    if (tag.iconPath) {
      r = <img key={tag.iconPath} className="tag-icon-image" title={tag.name} data-original-title={tag.name} src={tag.iconPath} />;
    }

    return r;
  });
};

// const makeJumpToHref = (reg) => `/data-hub/regulations/by-regulation/?regulation_id=${reg.id}`;

const makeNestedTd = ([heading, value], i) => {
  return (
    <div className="rt-td" key={i}>
      <div className="heading">
        {heading}
      </div>
      <div className="value">
        {value || "–"}
      </div>
    </div>
  );
};

// eslint-disable-next-line react/display-name
const subComponent = (regulations, handleJumpTo) => row => {
  const regulation = regulations[row.index];

  const newTabIcon = <i className="fa fa-external-link"></i>;
  const allRelated = regulation.allRelated.map(r => <a key={r.id} target="_blank" onClick={handleJumpTo(r)}>{r.name}</a> );
  const subComponentData = [
    ["Description", regulation.description],
    ["Related Regulations/legislation", (allRelated.length > 0 ? allRelated : "–")]
  ];
  const tds = subComponentData.map(makeNestedTd);
  const standardsHref = `/data-hub/regulations/all-data/?country_regulation_id=${regulation.id}`;
  let regulationStandardsLink;
  const stopPropagation = e => e.stopPropagation();
  if (regulation.hasNumericalStandards) {
    regulationStandardsLink = <a target="_blank" onClick={stopPropagation} className="see-numerical-standards btn btn-primary btn-block" href={standardsHref}>See {regulation.numericalStandardsCount} numerical standards {newTabIcon}</a>;
  } else {
    regulationStandardsLink = <a target="_blank" onClick={stopPropagation} disabled className="see-numerical-standards btn btn-primary btn-block">Regulation does not define any numerical standards</a>;
  }
  return (
    <div>
      <div className="rt-tr sub-component">
        {tds[0]}
        <div className="rt-td">
        </div>
      </div>
      <div className="rt-tr sub-component">
        {tds[1]}

        <div className="rt-td">
          {regulationStandardsLink}
        </div>
      </div>
    </div>
  );
};

class Table extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: {},
      page: 0,
      sorted: [{ id: "td-2", desc: true }, { id: "td-1", desc: true }]
    };

    this.regulationCountryTable = React.createRef();
  }

  pageSize() {
    return 4;
  }

  componentDidUpdate(prevProps) {
    // Only respond to genuine prop changes from the parent (a jump request or a new
    // regulation set) — NOT to our own setState (expand / page / sort), so user
    // interaction state is preserved. componentDidUpdate does not fire on mount,
    // matching the old componentWillReceiveProps.
    if (prevProps.jumpToRegulationId === this.props.jumpToRegulationId &&
        prevProps.visibleRegulations === this.props.visibleRegulations) {
      return;
    }

    let newState = {};

    if (this.props.jumpToRegulationId) {
      const jtri = this.props.jumpToRegulationId;

      const indexOfRegulation = this.props.visibleRegulations.findIndex(r => r.id === jtri);
      const pageToJumpTo = Math.floor(indexOfRegulation / this.pageSize());
      const viewIndex = indexOfRegulation % this.pageSize();
      const newExpanded = {};
      newExpanded[viewIndex] = true;

      newState = {
        page: pageToJumpTo,
        expanded: newExpanded,
        sorted: []
      };
    } else {
      newState = {
        sorted: [],
        expanded: {},
        page: 0
      };
    }

    this.setState(newState);
  }

  render () {
    const regulations = this.props.visibleRegulations;

    const data = regulations.map((e) => {
      const purposes = this.props.purposes.filter(purpose => e.purposeIds.includes(purpose.id));
      const targets = this.props.targets.filter(target => e.targetIds.includes(target.id));
      const purposeIcons = makeIcons(purposes);
      const targetIcons = makeIcons(targets);
      return [
        e.name,
        e.yearPassed,
        e.yearUpdated,
        purposeIcons,
        targetIcons
      ];
    });
    const tableData = [
      ["Document name", "Year Passed", "Year Updated", "Application", "Target sector"],
    ].concat(data);

    const expandRow = (expandedState, i) => {
      const newExpandedObject = Object.assign({}, this.state.expanded);

      newExpandedObject[i] = !this.state.expanded[i];
      this.setState({ expanded: newExpandedObject });
    };

    const onPageChange = newPageIndex => {
      $(this.regulationCountryTable.current).closest(".card").prev()[0].scrollIntoView();

      this.setState({
        expanded: {},
        page: newPageIndex
      });
    };

    const page = this.state.page;
    const expanded = this.state.expanded;

    const handleJumpTo = jumpToRegulation => e => {
      e.preventDefault();
      e.stopPropagation();

      this.props.onJumpTo(jumpToRegulation);
    };

    const onSortedChange = newSorted => {
      this.setState({
        sorted: newSorted,
        expanded: {},
        page: 0
      });
    };

    const reactTableProps = {
      getTrGroupProps: (state, rowInfo, column) => {
        if (!rowInfo) { return {}; }
        column;

        const expandRowOnClick = () => {
          expandRow(state.expanded, rowInfo.viewIndex);
        };

        return {
          style: {
            background: state.expanded[rowInfo.viewIndex] ? "#E5EFF5" : null
          },
          onClick: expandRowOnClick
        };
      },
      expanded: expanded,
      defaultPageSize: this.pageSize(),
      page: page,
      onPageChange: onPageChange,
      sorted: this.state.sorted,
      onSortedChange: onSortedChange
    };

    return (
      <div ref={this.regulationCountryTable} className="table">
        <div className="instructions">Click on rows to expand for more information</div>
        <BasicReactTableWrapper
          data={tableData}
          subComponent={subComponent(regulations, handleJumpTo)}
          minWidths={[150, 40, 40, 60, 100]}
          labelColumnIndex={() => true}
          reactTableProps={reactTableProps}
        />
      </div>
    );
  }
}

const regulationShape = PropTypes.shape({
  id: PropTypes.number.isRequired
});

Table.propTypes = {
  visibleRegulations: PropTypes.arrayOf(regulationShape),
  targets: PropTypes.arrayOf(purposeShape).isRequired,
  purposes: PropTypes.arrayOf(purposeShape).isRequired,
  jumpToRegulationId: PropTypes.number,
  onJumpTo: PropTypes.func.isRequired

};

export { regulationShape, Table };
